// extracted by mini-css-extract-plugin
var _1 = "AIButtonIconGrey-moduleaiButtonIconGrey__ijG4d AIButtonIcon-moduleaiButtonIcon__WNIqX";
var _2 = "AIButtonIconGrey-moduleloading__Q9lCb";
export { _1 as "aiButtonIconGrey", _2 as "loading" }
